import { render } from "./NewEmployees.vue?vue&type=template&id=7748ebca&ts=true"
import script from "./NewEmployees.vue?vue&type=script&lang=ts"
export * from "./NewEmployees.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__